/*
    Слайдер с цитатами
*/

class BlockquoteSlider {
    constructor(slider) {
        this.$slider = $(slider);
        this.$container = this.$slider.closest('.js-bq-slider-wrap');
        this.$previews = this.$container.find('.js-bq-slider-preview');

        this.init();
        this.bindMouse();
        this.bindClick();
        this.bindButtons();
    }



    init() {
        // Инициализация слайдера
        this.swiper = new Swiper(this.$slider, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            roundLengths: true,
            speed: 300,
            a11y: true,
            grabCursor: false,
            simulateTouch: false,
            on: {
                // Подсвечиваем активную кнопку
                slideChange: () => {
                    const index = this.swiper.realIndex;

                    this.$previews
                        .removeClass('_active')
                        .eq(index)
                        .addClass('_active');
                }
            }
        });
    }


    // Переключение кликом по превью
    bindButtons() {
        this.$previews.on('click', (e) => {
            const index = $(e.target).closest('.js-bq-slider-preview').index() + 1;
            this.swiper.slideTo(index);
        });
    }


    // Курсор-стрелки
    bindMouse() {
        if (App.mobile) {
            return;
        }

        let containerW;
        let containerX;

        this.$container
            .on('mouseenter', () => {
                // кэшируем ширину и позицию слайдера
                containerX = this.$container.offset().left;
                containerW = this.$container.width();
            })
            .on('mousemove', (e) => {
                const x = e.pageX;

                // Курсор в левой и правой половине — разный
                if (x - containerX < containerW / 2) {
                    this.$slider.addClass('_left');
                } else {
                    this.$slider.removeClass('_left');
                }
            });
    }


    // Переключение кликом
    bindClick() {
        if (App.mobile) {
            return;
        }

        this.$slider.on('click', (e) => {
            const containerX = this.$container.offset().left;
            const containerW = this.$container.width();
            const x = e.pageX;

            // В зависимости от того, в какой половине произошёл клик,
            // переключаем влево или вправо
            if (x - containerX < containerW / 2) {
                this.swiper.slidePrev();
            } else {
                this.swiper.slideNext();
            }
        });
    }
}



App.H.find('.js-bq-slider').each(function () {
    new BlockquoteSlider(this);
});



// WEBPACK FOOTER //
// ./_src/js/modules/BlockquoteSlider.js